import { Modal as MantineModal } from "@mantine/core";
import styles from "../modal.module.scss";
import type { CustomModalRootFactory, IProps } from "./modal-root.types";
import { componentWrapper } from "../../../utilities";

const ModalRoot = componentWrapper<CustomModalRootFactory, IProps>(
    "ModalRoot",
    ({ variant = "default", ...otherProps }, ref) => {
        return (
            <MantineModal.Root
                ref={ref}
                data-variant={variant}
                classNames={{
                    root: styles["root"],
                    overlay: styles["overlay"],
                    content: styles["content"],
                    header: styles["header"],
                    title: styles["title"],
                    close: styles["close"],
                    inner: styles["inner"],
                }}
                {...otherProps}
            />
        );
    }
);

export { ModalRoot };
